module.exports = __webpack_public_path__ + "img/27.869bd132.png";